import React from 'react';
import {Outlet} from 'react-router-dom';
import {UserProvider} from '../contexts/UserContext';
import {FeatureConfigProvider} from "../contexts/FeatureConfigContext";

const PrivateLayout = () => {
    return (
        <UserProvider>
            <FeatureConfigProvider>
                <Outlet />
            </FeatureConfigProvider>
        </UserProvider>
    );
};

export default PrivateLayout;
